export default "/images/arrow-left.svg?8edfe59d267ad47fbed40e1710984375";